import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import Errorcontent from "../components/Errorcontent";
import Header from "../components/Header";

const Error = () => {
  return (
    <>
      <Header />
      <main>
        <Breadcrumb name="error" />
        <Errorcontent />
        <Footer />
      </main>
      <Scrolltop />
    </>
  );
};

export default Error;
